// @flow
import React, { Fragment } from 'react';
import withClickOutside from 'react-onclickoutside';
import UserMenuItem from 'components/base/UserMenuItem';
import './UserMenu.scss';

type Props = {
  onClick(): void,
  onLogout(): Promise<*>,
  username: string,
  rule: string,
};

const UserMenu = ({ onClick, onLogout, username, rule }: Props) => {
  return (
    <div className="user-menu-wrapper">
      <div className="user-menu-positioner">
        <div className="rotated-square" />
        <div className="user-menu" onClick={onClick}>
          <div className="menu-items">
            {/* <UserMenuItem to={`/@${username}`}>마이페이지</UserMenuItem> */}
            <UserMenuItem to="/orders">주문 목록</UserMenuItem>
            <UserMenuItem to="/wish">찜 목록</UserMenuItem>
            {/* <UserMenuItem to="/estimate">견적 목록</UserMenuItem> */}
            <div className="separator" />
            <UserMenuItem to="/settings">회원정보수정</UserMenuItem>
            <UserMenuItem onClick={onLogout}>로그아웃</UserMenuItem>
            {rule === 'admin' && (
              <div className="admin-cell">
                <div className="separator" />
                <div className="admin-menu">관리자 메뉴</div>
                <UserMenuItem to="/estimate-box">견적서 등록</UserMenuItem>
                {/* <UserMenuItem to="/write">포스트 등록</UserMenuItem>
                <UserMenuItem to="/write?type=product">상품 등록</UserMenuItem>
                <UserMenuItem to="/write?type=banner">배너 등록</UserMenuItem>
                <UserMenuItem to="/write?type=brand">파트너 등록</UserMenuItem>
                <UserMenuItem to="/write?type=partner">브랜드 등록</UserMenuItem>
                <UserMenuItem to="/write?type=letter">뉴스레터 등록</UserMenuItem>
                <UserMenuItem to="/write?type=event">이벤트 등록</UserMenuItem> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// $FlowFixMe
export default withClickOutside(UserMenu, {
  handleClickOutside(instance) {
    return instance.props.onClickOutside;
  },
});



// WEBPACK FOOTER //
// ./src/components/base/UserMenu/UserMenu.js